import React, {useEffect, useRef, useState, useCallback} from 'react'
import { Modal, message, Spin } from 'antd';
import './index.scss'
import moment from 'moment'
import { OCR2WordFile, stampFile } from 'src/https/template'
import { websendtopc, queryinfo, signoutforSession } from 'src/https/userCente'
import FileView from "src/pages/common/fileView"
import { saveAs } from 'file-saver'

import WxCode from 'src/images/erweima.jpg'
import DnImg from 'src/images/dn.png'
import GeneralImg from 'src/images/btn_General-Bill.png'
import BusinessImg from 'src/images/btn_business-license.png'
import IDCardImg from 'src/images/btn_ID-card.png'
import GMPImg from 'src/images/btn_GMP.png'
import InstitutionImg from 'src/images/btn_Medical-institution-license.png'
import DrugImg from 'src/images/btn_Drug-trade-license.png'
import GSPImg from 'src/images/btn_GSP.png'
import InvoiceImg from 'src/images/btn_Invoice-information.png'
import TaxImg from 'src/images/btn_Tax-registration-certificate.png'
import DrugProductionImg from 'src/images/btn_Drug-production-license.png'
import FoodImg from 'src/images/btn_Food-circulation-license.png'
import PowerImg from 'src/images/btn_Power-of-attorney-of-legal-person.png'
import BusinesscardImg from 'src/images/btn_businesscard.png'
import SealextractionImg from 'src/images/btn_Sealextraction.png'

interface OcrProps {
	ocrData: any;
	setOcrData: any;
}

interface ocrMenu {
  name: string;
	icon: any;
  type: string;
}

const OcrList: Array<ocrMenu> = [{
	name: '营业执照',
	icon: BusinessImg,
	type: 'businessLicense2'
},{
	name: '身份证',
	icon: IDCardImg,
	type: 'idCard'
},{
	name: '通用文字',
	icon: GeneralImg,
	type: 'basic'
},{
	name: 'GMP证书',
	icon: GMPImg,
	type: 'gmp'
},{
	name: '医疗机构许可证',
	icon: InstitutionImg,
	type: 'mipl'
},{
	name: '药品经营许可证',
	icon: DrugImg,
	type: 'ddl'
},{
	name: 'GSP证书',
	icon: GSPImg,
	type: 'gsp'
},{
	name: '开票信息识别',
	icon: InvoiceImg,
	type: 'bill'
},{
	name: '税务登记证',
	icon: TaxImg,
	type: 'tax'
},{
	name: '药品生产许可证',
	icon: DrugProductionImg,
	type: 'dpl'
},{
	name: '食品流通许可证',
	icon: FoodImg,
	type: 'food'
},{
	name: '法人授权委托书',
	icon: PowerImg,
	type: 'person'
},{
	name: '名片识别',
	icon: BusinesscardImg,
	type: 'business_card'
},{
	name: '印章提取',
	icon: SealextractionImg,
	type: 'stampFile'
}]
const Page: React.FC<OcrProps> = ({ocrData, setOcrData}) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const inputRef = useRef<HTMLInputElement>(null)
	const upRef = useRef<HTMLInputElement>(null)
	const ocrTime = useRef<any>(null)

	// 获取上一次识别内容
	const getOcrInfo = useCallback(() => {
		queryinfo().then((res: any) => {
			const {data:ocrInfo} = res
			if(ocrInfo.status === 0){
				setOcrData(ocrInfo.data)
			}else{
				setOcrData('')
			}
		})
	},[setOcrData])

	useEffect(() => {
		if(!ocrTime.current){
			ocrTime.current = setInterval(getOcrInfo, 10000)
		}
	}, [ocrTime, getOcrInfo])

	

	// 复制 
	const copyText = (text: string) => {
		const inputNode = inputRef.current
		if(inputNode && inputNode !== null){
			inputNode.value = text;
			inputNode.select()
			document.execCommand('Copy')
			message.success('复制成功')
		}
	}

	// 打开图文对比
	const showModal = () => {
		if(ocrData.picurl){
			setIsModalOpen(true);
		}else{
			message.warning("暂无图文，请先上传识别文件！")
		}
  };
	// 关闭图文对比
	const handleCancel = () => {
    setIsModalOpen(false);
  };

	// 识别内容
	const showOcrHtml = (content:string, isCopy: boolean) => {
		try{
			const objContent = JSON.parse(content)
			const arrContent = []
			for(const item in objContent){
				arrContent.push({
					key: item,
					value: objContent[item].words
				})
			}
			return (<div className='recognition-table'>
				{
					arrContent.map((item, index) => {
						return (<div key={index} className='table-tr'>
							{
								item.key === '通用文字' ? '' : <div className='td-tile'>{item.key}</div>
							}
							<div className='td-ocr-content'>
								<div className='ocr-val'>
									{
										item.key === '通用文字' && item.value.length ? item.value.map((text:any) => {
											return <p>{text}</p>
										}) : item.value
									}
								</div>
								{
									isCopy && <div className='ocr-copy-operation'>
										<div className='ocr-copy-btn' onClick={() => copyText(item.key === '通用文字' && item.value.length ? item.value.join('') : item.value)}>复制</div>
									</div>
								}
							</div>
						</div>)
					})
				}
			</div>)
		} catch (e) {
			return ''
		}
	}

	// 上传文件
	const uploadFile = (item: any) => {
		const upInput = upRef.current
		if(upInput && upInput !== null){
			if(upInput.onchange !== undefined){
				upInput.onchange = (e:any) => {
					const file = e.target.files[0]
					if(file.size > 20 * 1024 * 1024){
							message.warning('文件大小不能超过20M');
							return
					}
					let formData = new FormData();
					formData.append("file",file);
					formData.append("type",item.type);
					setLoading(true)
					try{
						upInput.value = ""
						if(item.type === 'stampFile'){
							stampFile(formData).then((res:any) => {
								setLoading(false)
								const {data} = res
								if(data.status === 0){
									clearInterval(ocrTime.current)
									setOcrData({...ocrData, ocrname: item.ocrname, picurl: data.data, type: 'stampFile'})
								}else{
									message.error(data.msg)
								}
							})
						}else{
							OCR2WordFile(formData).then((res:any)=>{
								const {data} = res
								setLoading(false)
								if(data.status === 0){
									let tempOrigin = 'http://192.168.123.16:8082/view2'
									if(window.location.origin.includes('001pt.com')){
										tempOrigin = 'https://www.001pt.com/view2'
									}
									const content = data.data.values
									const picurl = tempOrigin + data.data.tempFile.split('/temp')[1]
									setOcrData({...ocrData, ocrname: item.ocrname, content, picurl, type: ''})
	
									// 识别成功后保存
									websendtopc({content,picurl,type:item.ocrname}).then(() => {
										
									})
								}else{
										message.error(data.msg || '识别失败，请重试');
								}
							})
						}
						clearInterval(ocrTime.current)
						ocrTime.current = setInterval(getOcrInfo, 10000)
					}catch(e){
						setLoading(false)
					}
				}
			}
			upInput.click()
		}
	}

	// 退出登录
	const logoOut = async () => {
		const {data} = await signoutforSession()
		if(data.status === 0){
			setOcrData('')
		}else{
			message.error(data.msg)
		}
	}

	return (
		<div className='page-container'>
			<div className='page-top-container'>
				<div className='page-top-user'>
					<div className='page-wx-user'>
						<img className='page-wx-user-img' src={ocrData.avatarurl} alt='wx'/>
						<div className='page-wx-user-box'>
							<p className='user-name'>{ocrData.nickname}</p>
							<div className='log-out-btn' onClick={logoOut}>退出登录</div>
						</div>
					</div>
					<div className='synchronization-time'>
					最后同步时间: {moment(ocrData.dtime).format('YYYY-MM-DD HH:mm:ss')}
					</div>
				</div>
				<div className='page-top-step'>
					<div className='page-step'>
						<div className='page-step-title'>小程序操作步骤：</div>
						<p>第一步：使用微信扫一扫右边“001图文识别”小程序二维码，登陆小程序操作。</p>
						<p>第二步：在“001图文识别”小程序中选择对应资质类型拍照上传图片，开始自动识别。</p>
						<p>第三步：自动识别成功后，点击页面下方“发送到电脑端”，同步后即可进行复制粘贴。</p>
					</div>
					<div className='page-wx-code'>
						<img src={WxCode} alt=""/>
					</div>
				</div>
			</div>
			<div className='page-wrapper'>
				<div className='page-ocr-title'>
					<div className='ocr-title'>
						<img src={DnImg} alt=''/>
						电脑端本地上传资质自动识别
					</div>
					{
						ocrData.type !== 'stampFile' && <div className='TSC-btn' onClick={showModal}>图文对比</div>
					}
				</div>
				<input className='ocr-copy-input' type="text" ref={inputRef}/>
				<input className='ocr-copy-input' type="file" ref={upRef} accept="image/jpeg,image/png,image/bmp"/>
				<Spin tip="识别中..." spinning={loading}>
					<div className='page-ocr-content'>
						<div className='ocr-menu-wrapper'>
							{
								OcrList.map((item, index) => {
									return (
										<div key={index} className={`ocr-menu-list ${ocrData.ocrname === index && 'active'}`} onClick={() => uploadFile({...item, ocrname:index})}>
											<img src={item.icon} alt=''/>{item.name}
										</div>
									)
								})
							}
						</div>
						{ocrData.type === 'stampFile' ? <div className='ocr-stamp-bor'>
							<img className='ocr-stamp' src={ocrData.picurl} alt=""/>
							<div className='ocr-save-stamp' onClick={() => saveAs(ocrData.picurl, 'stamp')}>下载到本地</div>
						</div> : showOcrHtml(ocrData.content, true)}
					</div>
				</Spin>
			</div>
			<Modal 
				title={null} 
				centered
				width={"95%"}
				footer={null}
				maskClosable={false}
				open={isModalOpen} 
				onCancel={handleCancel}
			>
        <div className='modal-TSC'>
					<FileView url={ocrData.picurl}/>
					<div className='modal-ocr-content'>
						{showOcrHtml(ocrData.content, false)}
					</div>
				</div>
      </Modal>
		</div>
	)
}

export default Page;